import { render, staticRenderFns } from "./errmsg.vue?vue&type=template&id=f601e61c&scoped=true"
import script from "./errmsg.vue?vue&type=script&lang=js"
export * from "./errmsg.vue?vue&type=script&lang=js"
import style0 from "./errmsg.vue?vue&type=style&index=0&id=f601e61c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f601e61c",
  null
  
)

export default component.exports